import httpService from './http.service';

const paymentGatewaysService = {
  getAllPaymentGateways,
  getPaymentGatewayById,
  createPaymentGateway,
  updatePaymentGateway,
  removePaymentGateway,
  performPaymentGatewayAction,

  // Webhooks
  getPaymentGatewayWebhooks,
  createPaymentGatewayWebhook,
  updatePaymentGatewayWebhook,
  deletePaymentGatewayWebhook,

  getPaymentGatewayWebhookEvents,

  getAvailablePaymentGateways,
  getAvailablePaymentMethods,
  getAvailableChargeStatus,
};

// Payment Gateways

function getAllPaymentGateways() {
  return httpService.get('/company-payment-gateway');
}

function getPaymentGatewayById(id) {
  return httpService.get(`/company-payment-gateway/${id}`);
}

function createPaymentGateway(gateway) {
  return httpService.post('/company-payment-gateway', gateway);
}

function updatePaymentGateway(id, gateway) {
  return httpService.put(`/company-payment-gateway/${id}`, gateway);
}

function removePaymentGateway(id) {
  return httpService.delete(`/company-payment-gateway/${id}`);
}

function performPaymentGatewayAction(id, action, params = {}) {
  return httpService.post(`/company-payment-gateway/${id}/perform-action`, {
    action,
    params,
  });
}

// Payment Gateway Webhooks
function getPaymentGatewayWebhooks(id) {
  return httpService.get(`/company-payment-gateway/${id}/webhooks`);
}

function createPaymentGatewayWebhook(id) {
  return httpService.post(`/company-payment-gateway/${id}/webhooks`, {});
}

function updatePaymentGatewayWebhook(gatewayId, webhookId, webhook) {
  return httpService.put(
    `/company-payment-gateway/${gatewayId}/webhooks/${webhookId}`,
    webhook,
  );
}

function deletePaymentGatewayWebhook(gatewayId, webhookId) {
  return httpService.delete(
    `/company-payment-gateway/${gatewayId}/webhooks/${webhookId}`,
  );
}

function getPaymentGatewayWebhookEvents(gatewayId, webhookId) {
  return httpService.get(
    `/company-payment-gateway/${gatewayId}/webhooks/${webhookId}/events`,
  );
}

// Params

function getAvailablePaymentGateways() {
  return httpService.get('/available-payment-gateway');
}

function getAvailablePaymentMethods() {
  return httpService.get('/available-payment-methods');
}

function getAvailableChargeStatus() {
  return httpService.get('/available-charge-status');
}

export default paymentGatewaysService;
